export var UserRole;
(function (UserRole) {
    UserRole["ADMIN"] = "ADMIN";
    UserRole["MANAGER"] = "MANAGER";
    UserRole["DEVELOPER"] = "DEVELOPER";
    UserRole["VIEWER"] = "VIEWER";
})(UserRole || (UserRole = {}));
export * from './auth.js';
export * from './code-analysis.js';
export * from './nlqDependencyQuery.js';
export * from './alda.js';
export var WorkspaceStatus;
(function (WorkspaceStatus) {
    WorkspaceStatus["ACTIVE"] = "ACTIVE";
    WorkspaceStatus["ARCHIVED"] = "ARCHIVED";
    WorkspaceStatus["DRAFT"] = "DRAFT";
})(WorkspaceStatus || (WorkspaceStatus = {}));
export var ProjectStatus;
(function (ProjectStatus) {
    ProjectStatus["PLANNING"] = "PLANNING";
    ProjectStatus["ASSESSMENT"] = "ASSESSMENT";
    ProjectStatus["POC"] = "POC";
    ProjectStatus["PILOT"] = "PILOT";
    ProjectStatus["MIGRATION"] = "MIGRATION";
    ProjectStatus["TESTING"] = "TESTING";
    ProjectStatus["COMPLETED"] = "COMPLETED";
    ProjectStatus["CANCELLED"] = "CANCELLED";
})(ProjectStatus || (ProjectStatus = {}));
export var TemplateCategory;
(function (TemplateCategory) {
    TemplateCategory["ASSESSMENT"] = "ASSESSMENT";
    TemplateCategory["POC"] = "POC";
    TemplateCategory["PILOT"] = "PILOT";
    TemplateCategory["WORKFLOW"] = "WORKFLOW";
})(TemplateCategory || (TemplateCategory = {}));
export var TemplateApproach;
(function (TemplateApproach) {
    TemplateApproach["DISCOVERY_FIRST"] = "DISCOVERY_FIRST";
    TemplateApproach["MINIMAL_SCOPE"] = "MINIMAL_SCOPE";
    TemplateApproach["PRODUCTION_SCALE"] = "PRODUCTION_SCALE";
    TemplateApproach["CONTEXT_ADAPTIVE"] = "CONTEXT_ADAPTIVE";
})(TemplateApproach || (TemplateApproach = {}));
//# sourceMappingURL=index.js.map